import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { ProductionEntityList } from '@data/keyIssues/key-issues';
import { initializeRequiredData } from '@data/pickList/pick-list';
import { accountMasterList } from '@data/weeklyVariance/weekly-variance';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
// import { Auth } from 'aws-amplify';
import { AuthService } from '@modules/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class CommonDataService{
  stausUser: boolean;
  userID: any;
  
  private timer: any;
  public isExpired: boolean = false;
  checkAuth: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  userInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  userData: BehaviorSubject<any> = new BehaviorSubject<[]>([]);

  constructor(private http: HttpClient, private zone: NgZone, private router: Router, private authService: AuthService){ }


  createAuthorizationToken() {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.createAuthorizationToken , {"data":"auth"} ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  refreshAuthorizationToken() {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.refreshAuthToken , {"data":"auth"} ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  isIDMSessionActive() {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.isIDMSessionActive).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getUser() {
    return this.http.post<any>(environment.apiUrl+ ApiPaths.getUserDetails , {"data":"auth"} ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getDownload(uuidNum: any): Observable<any>{
    const payload = {
      uuid : uuidNum
    };
      return this.http.post(environment.reportUrl + "/accessWeeklyPSR" , JSON.stringify(payload), {observe:'response',responseType:'blob'}).pipe(
        map((res: any) => {
          return res;
        })
      );
    }

  getPicklistCategories(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAllPicklistCategories).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getProductionEntities(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getProductionEntities ).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getAccountMasterList(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAccountMasterList).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  fetchAllCommonData(){
    this.getPicklistCategories().subscribe(r=>{
      if(r.status=="SUCCESS" && r.serviceResult)
        initializeRequiredData(r.serviceResult);
    });
    this.getProductionEntities().subscribe(r=>{
      if(r.status=="SUCCESS" && r.serviceResult)
        ProductionEntityList.next(r.serviceResult);
    });
    
    this.getAccountMasterList().subscribe(r=>{
      if(r.status=="SUCCESS" && r.serviceResult)
        accountMasterList.next(r.serviceResult);
    });
  }

  getDisUser() {
    return this.http.get<any>(environment.reportUrl+ ApiPaths.getDistroUserUuid).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  
  idleCookieSet(){
    const endTime:any = window.localStorage.getItem('cookieEndTimer');
    const expiryTime = endTime;
    const currentTime = new Date().getTime();
    const remainingTime = (expiryTime - currentTime)/1000;
    // console.log("Expiry = "  + expiryTime, "Current = " + currentTime);
    // console.log("remainingTime = " + remainingTime);
    

    if(remainingTime < 300 && remainingTime > 0){
      this.refreshAuthorizationToken().subscribe(r=>{
        if(r.serviceResult.expiryEpochTime != null){
          window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
          window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime); 
        }
      });
      // this.timer = setTimeout(() => {
      //   // this.isExpired = true;
      //   // this.authService.logout();
      //   // this.refreshAuthorizationToken().subscribe(r=>{
      //   //   if(r.status=="SUCCESS"){
      //   //     window.localStorage.setItem('cookieEndTimer', r.serviceResult.expiryEpochTime);
      //   //     window.localStorage.setItem('cookieStartTimer', r.serviceResult.issueAtEpochTime); 
      //   //   }
      //   // });
      // }, remainingTime)
    }else if(remainingTime < 0){
      this.isExpired = true;
      this.authService.logout();
    }
}

stopTimer(){
clearTimeout(this.timer)
}

}
